import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../../../../Styled/Box";
import { RawButton } from "../../../../../Styled/Button";
import Icon, { StyledIcon } from "../../../../../Styled/Icon";
import { TextSpan } from "../../../../../Styled/Text";
import Spacing from "../../../../../Styled/Spacing";
import Clipboard from "../../../../Clipboard";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const EmbedSection = _ref => {
  let {
    shareUrl
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const iframeCode = shareUrl !== null && shareUrl !== void 0 && shareUrl.url && shareUrl.url.length > 0 ? "<iframe style=\"width: 720px; height: 600px; border: none;\" src=\"".concat(shareUrl.url, "\" allowFullScreen mozAllowFullScreen webkitAllowFullScreen></iframe>") : "";
  return /*#__PURE__*/_jsxs(Box, {
    column: true,
    children: [/*#__PURE__*/_jsx(RawButton, {
      onClick: () => setIsOpen(prev => !prev),
      children: /*#__PURE__*/_jsxs(_StyledBox, {
        children: [/*#__PURE__*/_jsx(TextSpan, {
          semiBold: true,
          isLink: true,
          medium: true,
          children: t("share.embedTitle")
        }), /*#__PURE__*/_jsx(StyledIcon, {
          glyph: isOpen ? Icon.GLYPHS.opened : Icon.GLYPHS.closed,
          styledWidth: "10px",
          light: true
        })]
      })
    }), isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      }), /*#__PURE__*/_jsx(Explanation, {
        children: t("share.embedDescription")
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      }), /*#__PURE__*/_jsx(Clipboard, {
        text: !(shareUrl !== null && shareUrl !== void 0 && shareUrl.shorteningInProgress) ? iframeCode : "",
        inputPlaceholder: t("share.shortLinkShortening")
      })]
    })]
  });
};
const Explanation = styled(TextSpan).withConfig({
  displayName: "EmbedSection__Explanation",
  componentId: "sc-8q0am6-0"
})(["opacity:0.8;"]);
var _StyledBox = styled(Box).withConfig({
  displayName: "EmbedSection___StyledBox",
  componentId: "sc-8q0am6-1"
})(["align-items:center;justify-content:space-between;width:100%;"]);